import React from 'react';
//import PersonIcon from '@mui/icons-material/Person';
//import PaidIcon from '@mui/icons-material/Paid';
import FaceIcon from '@mui/icons-material/Face';
import RedeemIcon from '@mui/icons-material/Redeem';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import StoreIcon from '@mui/icons-material/Store';
import MoneyIcon from '@mui/icons-material/Money';
import CasinoIcon from '@mui/icons-material/Casino';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import BookIcon from '@mui/icons-material/Book';
import SecurityIcon from '@mui/icons-material/Security';
//import UploadFileIcon from '@mui/icons-material/UploadFile';
//import CreditScoreIcon from '@mui/icons-material/CreditScore';
//import ReceiptIcon from '@mui/icons-material/Receipt';
import ClearIcon from '@mui/icons-material/Clear';
//import RuleIcon from '@mui/icons-material/Rule';
//import SecurityIcon from '@mui/icons-material/Security';

export interface HelpRelation {
	group_id: string,
	id: string,
}

export interface HelpData {
	id: string,
	title: string,
	body: string,
	notice: boolean,
	relations: HelpRelation[]
	regist_time: string,
	update_time: string,
}

export interface HelpDict {
	[key:string]:HelpData[];
}

export const HelpGroupName:{[key:string]:string;}  = {
	"owner":"審査と作家登録",
	"item":"商品の登録",
	"consign":"納品",
	"sale":"販売と売上確定",
	"lottery":"抽選販売",
	"prior":"先行販売",
	"secret":"シークレット",
	"book":"電子書籍（戯曲）",
	"fee":"手数料",
	"bye":"商品引取と委託終了",
	"other":"その他",
};

export const HelpGroupStory:{[key:string]:string;}  = {
	"owner":"事前審査から会員登録・作家登録まで",
	"item":"取り扱い可能な商品と登録方法",
	"consign":"納品書の作成と納品時の注意事項",
	"sale":"販売と宣伝から売上を受け取る支払申請まで",
	"lottery":"販売開始直後は抽選販売になります",
	"prior":"特定のお客様に確実にご購入いただく方法",
	"secret":"商品ページにパスワードをかけて販売",
	"book":"戯曲専門の電子書籍",
	"fee":"架空ストアのご利用に必要な手数料",
	"bye":"商品の引き取り方から作家登録の削除まで",
	"other":"その他",
};

export const HelpGroupIcon:{[key:string]:JSX.Element;} ={
	"owner":<FaceIcon/>,
	"item":<RedeemIcon/>,
	"consign":<LocalShippingIcon/>,
	"sale":<StoreIcon/>,
	"lottery":<CasinoIcon/>,
	"prior":<VpnKeyIcon/>,
	"secret":<SecurityIcon/>,
	"book":<BookIcon/>,
	"fee":<MoneyIcon/>,
	"bye":<ClearIcon/>,
	"other":<FaceIcon/>,
}
